import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActionTypes } from '@rd/core/auth/store/actions/auth.actions';
import { map, take } from 'rxjs/operators';
import { UserInit } from './user-init.actions';

@Injectable()
export class UserInitEffects {
  constructor(private actions$: Actions) {}

  initialiseUserOnAuthLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActionTypes.LOGIN_USER),
      take(1),
      map(() => UserInit()),
    ),
  );
}
